import arrowForward from '../icons/arrow_forward.svg';
import arrowBack from '../icons/arrow_back.svg';
import arrowFirst from '../icons/arrow_first.svg';
import arrowLast from '../icons/arrow_last.svg';
import arrowFastForward from '../icons/fast_forward.svg';
import arrowFastRewind from '../icons/fast_rewind.svg';
export class PaginationOptions {
    constructor() {
        this.pagesizes = [10, 20, 50, 100, 250, 500, 1000, 2500, 5000];
    }
}
export class Pagination {
    constructor(options) {
        this.grid = null;
        this.visibleData = [];
        this.showStats = true;
        this.showPageSize = true;
        this.pagesizes = [10, 20, 50, 100, 250, 500, 1000, 2500, 5000];
        this.lastPage = 0;
        this.total = 0;
        this.visibleButtons = 5;
        this.firstVisiblePage = 0;
        this.lastVisiblePage = 0;
        this.firstVisibleElement = 0;
        this.lastVisibleElement = 0;
        this.enabled = false;
        this.pageSizeInputs = [];
        this.pageSizeSelectors = [];
        this.pageCounters = [];
        this.pageSizeSelects = [];
        this.pageButtons = [];
        this.pageNumberInputs = [];
        this.pageNumberOfSpans = [];
        this.pagesize = options.pagesize ? options.pagesize : 20;
        this.page = options.page ? options.page : 0;
        this.enabled = options.enabled ? options.enabled : false;
        this.visibleButtons = options.visibleButtons ? options.visibleButtons : 5;
        this.showStats = options.showStats ? options.showStats : true;
        this.showPageSize = options.showPageSize ? options.showPageSize : true;
        this.pagesizes = options.pagesizes ? options.pagesizes : this.pagesizes;
        this.update = this.update.bind(this);
        this.pageSizeChanged = this.pageSizeChanged.bind(this);
        this.pageSizeSelectChanged = this.pageSizeSelectChanged.bind(this);
        this.RenderPageSizeSelect = this.RenderPageSizeSelect.bind(this);
        this.onPageSizeChanged = this.onPageSizeChanged.bind(this);
        this.updateFirstLastVisibile = this.updateFirstLastVisibile.bind(this);
        this.RenderPageCounter = this.RenderPageCounter.bind(this);
        this.RenderPageCounterContent = this.RenderPageCounterContent.bind(this);
        this.RenderPageButtons = this.RenderPageButtons.bind(this);
        this.RenderPageButtonSet = this.RenderPageButtonSet.bind(this);
        this.buttonWindowBack = this.buttonWindowBack.bind(this);
        this.buttonWindowForward = this.buttonWindowForward.bind(this);
        this.firstButtonClickHandler = this.firstButtonClickHandler.bind(this);
        this.lastButtonClickHandler = this.lastButtonClickHandler.bind(this);
        this.updateControls = this.updateControls.bind(this);
        this.pageNumberChangeEvent = this.pageNumberChangeEvent.bind(this);
        this.goToPage = this.goToPage.bind(this);
        this.RenderPageSizeOnly = this.RenderPageSizeOnly.bind(this);
    }
    update(visibleData) {
        this.visibleData = visibleData;
        this.total = visibleData.length;
        let n = this.total / this.pagesize;
        this.lastPage = Math.ceil(n) - 1;
        if (this.lastVisiblePage - this.firstVisiblePage < this.visibleButtons) {
            this.firstVisiblePage = this.page;
            this.lastVisiblePage = this.firstVisiblePage + this.visibleButtons - 1;
        }
        if (this.page > this.lastPage) {
            this.page = this.lastPage;
            this.lastVisiblePage = this.page;
            this.firstVisiblePage = this.lastVisiblePage - this.visibleButtons + 1;
        }
        this.updateFirstLastVisibile();
    }
    updateFirstLastVisibile() {
        var _a;
        this.firstVisibleElement = this.page * this.pagesize;
        this.lastVisibleElement = this.firstVisibleElement + this.pagesize;
        if (this.lastVisibleElement > this.total) {
            this.lastVisibleElement = this.total;
        }
        if (this.lastVisiblePage < this.page) {
            this.lastVisiblePage = this.page;
            this.firstVisiblePage = this.lastVisiblePage - this.visibleButtons + 1;
            if (this.firstVisiblePage < 0) {
                this.firstVisiblePage = 0;
                this.lastVisiblePage = this.visibleButtons - 1;
            }
        }
        if (this.firstVisiblePage > this.page) {
            this.firstVisiblePage = this.page;
            this.lastVisiblePage = this.firstVisiblePage + this.visibleButtons - 1;
            if (this.lastVisiblePage > this.lastPage) {
                this.lastVisiblePage = this.lastPage;
                this.firstVisiblePage = this.lastVisiblePage - this.visibleButtons + 1;
            }
        }
        if (this.firstVisiblePage < 0) {
            this.firstVisiblePage = 0;
        }
        if (this.lastVisiblePage > this.lastPage) {
            this.lastVisiblePage = this.lastPage;
        }
        this.updateControls();
        (_a = this.grid) === null || _a === void 0 ? void 0 : _a.paginationChanged();
    }
    updateControls() {
        this.pageSizeInputs.forEach(input => {
            input.value = this.pagesize.toString();
        });
        this.pageSizeSelects.forEach(select => {
            select.value = "";
        });
        this.pageButtons.forEach(buttonSet => {
            buttonSet.innerHTML = '';
            this.RenderPageButtonSet(buttonSet);
        });
        this.pageCounters.forEach(pageCounter => {
            pageCounter.innerHTML = "";
            pageCounter.appendChild(this.RenderPageCounterContent());
        });
        this.pageNumberOfSpans.forEach(span => {
            span.innerHTML = this.renderOfSpanHtml();
        });
        this.pageNumberInputs.forEach(input => {
            input.value = (this.page + 1).toString();
        });
    }
    renderPagination() {
        const wrapper = document.createElement('div');
        wrapper.classList.add('dwc-datagrid-footer');
        return wrapper;
    }
    RenderPageSizeOnly() {
        const wrapper = document.createElement('div');
        wrapper.classList.add('dwc-datagrid-paginator');
        if (this.showPageSize) {
            const pageSelector = this.RenderPageSizeSelect();
            wrapper.appendChild(pageSelector);
            this.pageSizeSelectors.push(pageSelector);
        }
        const pageButtons = this.RenderPageButtons();
        wrapper.appendChild(pageButtons);
        return wrapper;
    }
    RenderPageSizeSelect() {
        let pageSizer = document.createElement('div');
        pageSizer.classList.add('dwc-datagrid-page-size-container');
        let pageSizeLabel = document.createElement('label');
        pageSizeLabel.textContent = 'Rows per page:';
        pageSizeLabel.classList.add('dwc-datagrid-page-size-label');
        pageSizer.appendChild(pageSizeLabel);
        let pageSize = document.createElement('input');
        pageSize.type = 'number';
        pageSize.value = this.pagesize.toString();
        pageSize.classList.add('dwc-datagrid-page-size');
        pageSize.addEventListener('change', this.pageSizeChanged);
        pageSizer.appendChild(pageSize);
        this.pageSizeInputs.push(pageSize);
        let pageSizeSelect = document.createElement('select');
        pageSizeSelect.classList.add('dwc-datagrid-page-size-select');
        pageSizeSelect.title = "Rows per page";
        pageSizeSelect.addEventListener('change', this.pageSizeSelectChanged);
        let option = document.createElement('option');
        option.value = '';
        option.textContent = 'Select';
        pageSizeSelect.appendChild(option);
        this.pageSizeSelects.push(pageSizeSelect);
        this.pagesizes.forEach(size => {
            let option = document.createElement('option');
            option.value = size.toString();
            option.textContent = size.toString();
            pageSizeSelect.appendChild(option);
        });
        pageSizer.appendChild(pageSizeSelect);
        return pageSizer;
    }
    pageSizeChanged(event) {
        let input = event.currentTarget;
        this.pagesize = Number(input.value);
        this.page = 1;
        this.pageSizeSelects.forEach(select => {
            select.value = "";
        });
        this.onPageSizeChanged();
    }
    pageSizeSelectChanged(event) {
        let select = event.currentTarget;
        if (select.value === "") {
            return;
        }
        this.pagesize = Number(select.value);
        this.pageSizeInputs.forEach(input => {
            input.value = this.pagesize.toString();
        });
        this.onPageSizeChanged();
        select.value = "";
    }
    onPageSizeChanged() {
        let currentStart = this.firstVisibleElement;
        this.page = Math.floor(currentStart / this.pagesize);
        let n = this.total / this.pagesize;
        this.lastPage = Math.ceil(n) - 1;
        if (this.lastPage * this.pagesize >= this.total) {
            this.lastPage = this.lastPage - 1;
        }
        this.updateFirstLastVisibile();
    }
    renderOfSpanHtml() {
        return `of <b>${this.lastPage + 1}</b> Total Items <b>${this.total}</b>`;
    }
    RenderPageCounter() {
        let pageCounter = document.createElement('div');
        pageCounter.classList.add('dwc-datagrid-page-counter');
        pageCounter.appendChild(this.RenderPageCounterContent());
        return pageCounter;
    }
    RenderPageCounterContent() {
        let counterContent = document.createElement('div');
        counterContent.classList.add('dwc-datagrid-page-counter-content');
        let label = document.createElement('label');
        label.innerText = "Page:";
        counterContent.appendChild(label);
        let pageNumber = document.createElement('input');
        pageNumber.type = 'number';
        pageNumber.value = (this.page + 1).toString();
        pageNumber.classList.add('dwc-datagrid-page-number');
        pageNumber.addEventListener('change', this.pageNumberChangeEvent);
        this.pageNumberInputs.push(pageNumber);
        counterContent.appendChild(pageNumber);
        let total = document.createElement('span');
        total.innerHTML = this.renderOfSpanHtml();
        total.classList.add('dwc-datagrid-page-total');
        this.pageNumberOfSpans.push(total);
        counterContent.appendChild(total);
        return counterContent;
    }
    RenderPageButtons() {
        const pageButtons = document.createElement('div');
        pageButtons.classList.add('dwc-datagrid-page-buttons');
        this.RenderPageButtonSet(pageButtons);
        this.pageButtons.push(pageButtons);
        return pageButtons;
    }
    RenderPageButtonSet(pageButtons) {
        let isFirstDisabled = this.page <= 0;
        let isLastDisabled = this.page >= this.lastPage;
        let firstButton = document.createElement('button');
        firstButton.innerHTML = arrowFirst;
        firstButton.title = 'First Page';
        firstButton.type = 'button';
        firstButton.disabled = isFirstDisabled;
        firstButton.classList.add('dwc-datagrid-page-button');
        firstButton.addEventListener('click', this.firstButtonClickHandler);
        pageButtons.appendChild(firstButton);
        // Jump Back 5 Pages
        let prevSetButton = document.createElement('button');
        prevSetButton.innerHTML = arrowFastRewind;
        prevSetButton.title = 'Jump Back 5 Pages';
        prevSetButton.type = 'button';
        prevSetButton.disabled = isFirstDisabled;
        prevSetButton.classList.add('dwc-datagrid-page-button');
        prevSetButton.addEventListener('click', this.buttonWindowBack);
        pageButtons.appendChild(prevSetButton);
        // One Page Back
        let prevOneButton = document.createElement('button');
        prevOneButton.innerHTML = arrowBack;
        prevOneButton.title = 'Previous Page';
        prevOneButton.type = 'button';
        prevOneButton.disabled = isFirstDisabled;
        prevOneButton.classList.add('dwc-datagrid-page-button');
        prevOneButton.addEventListener('click', () => {
            if (this.page > 0) {
                this.page--;
                this.updateFirstLastVisibile();
            }
        });
        pageButtons.appendChild(prevOneButton);
        // Page Number Buttons
        for (let page = this.firstVisiblePage; page <= this.lastVisiblePage; page++) {
            let button = document.createElement('button');
            button.textContent = (page + 1).toString();
            button.title = `Go to Page ${page + 1}`;
            button.type = 'button';
            button.classList.add('dwc-datagrid-page-button');
            if (page === this.page) {
                button.classList.add('dwc-datagrid-page-button-selected');
            }
            button.dataset.pageNumber = page.toString();
            button.addEventListener('click', this.goToPage);
            pageButtons.appendChild(button);
        }
        // One Page Forward
        let nextOneButton = document.createElement('button');
        nextOneButton.innerHTML = arrowForward;
        nextOneButton.title = 'Next Page';
        nextOneButton.type = 'button';
        nextOneButton.disabled = isLastDisabled;
        nextOneButton.classList.add('dwc-datagrid-page-button');
        nextOneButton.addEventListener('click', () => {
            if (this.page < this.lastPage) {
                this.page++;
                this.updateFirstLastVisibile();
            }
        });
        pageButtons.appendChild(nextOneButton);
        // Jump Forward 5 Pages
        let nextSetButton = document.createElement('button');
        nextSetButton.innerHTML = arrowFastForward;
        nextSetButton.title = 'Jump Forward 5 Pages';
        nextSetButton.type = 'button';
        nextSetButton.disabled = isLastDisabled;
        nextSetButton.classList.add('dwc-datagrid-page-button');
        nextSetButton.addEventListener('click', this.buttonWindowForward);
        pageButtons.appendChild(nextSetButton);
        // Last Page
        let lastButton = document.createElement('button');
        lastButton.innerHTML = arrowLast;
        lastButton.title = 'Last Page';
        lastButton.type = 'button';
        lastButton.disabled = isLastDisabled;
        lastButton.classList.add('dwc-datagrid-page-button');
        lastButton.addEventListener('click', this.lastButtonClickHandler);
        pageButtons.appendChild(lastButton);
    }
    buttonWindowBack() {
        const ordinal = this.page - this.firstVisiblePage;
        if (this.firstVisiblePage === 0) {
            this.page = 0;
            this.firstVisiblePage = 0;
            this.lastVisiblePage = this.visibleButtons - 1;
        }
        else {
            let newLastPage = this.firstVisiblePage - 1;
            let newFirstPage = newLastPage - this.visibleButtons + 1;
            if (newFirstPage < 0) {
                newFirstPage = 0;
                newLastPage = this.visibleButtons - 1;
            }
            this.firstVisiblePage = newFirstPage;
            this.lastVisiblePage = newLastPage;
            const newPage = newFirstPage + ordinal;
            this.page = newPage <= this.lastPage ? newPage : this.lastPage;
        }
        this.updateFirstLastVisibile();
    }
    buttonWindowForward() {
        const ordinal = this.page - this.firstVisiblePage;
        if (this.lastVisiblePage >= this.lastPage) {
            this.page = this.lastPage;
            this.lastVisiblePage = this.lastPage;
            this.firstVisiblePage = this.lastPage - this.visibleButtons + 1;
            if (this.firstVisiblePage < 0) {
                this.firstVisiblePage = 0;
            }
        }
        else {
            let newFirstPage = this.lastVisiblePage + 1;
            let newLastPage = newFirstPage + this.visibleButtons - 1;
            if (newLastPage > this.lastPage) {
                newLastPage = this.lastPage;
                newFirstPage = newLastPage - this.visibleButtons + 1;
                if (newFirstPage < 0) {
                    newFirstPage = 0;
                }
            }
            this.firstVisiblePage = newFirstPage;
            this.lastVisiblePage = newLastPage;
            const newPage = newFirstPage + ordinal;
            this.page = newPage <= this.lastPage ? newPage : this.lastPage;
        }
        this.updateFirstLastVisibile();
    }
    firstButtonClickHandler() {
        this.page = 0;
        this.firstVisiblePage = this.page;
        this.lastVisiblePage = this.firstVisiblePage + this.visibleButtons - 1;
        this.updateFirstLastVisibile();
    }
    lastButtonClickHandler() {
        this.page = this.lastPage;
        this.lastVisiblePage = this.page;
        this.firstVisiblePage = this.lastVisiblePage - this.visibleButtons + 1;
        this.updateFirstLastVisibile();
    }
    goToPage(event) {
        let button = event.currentTarget;
        this.page = Number(button.dataset.pageNumber);
        this.updateFirstLastVisibile();
    }
    pageNumberChangeEvent(event) {
        let input = event.currentTarget;
        let requestedPage = Number(input.value) - 1;
        if (isNaN(requestedPage) || requestedPage < 0 || requestedPage > this.lastPage) {
            input.value = (this.page + 1).toString();
            return;
        }
        this.page = requestedPage;
        this.firstVisiblePage = this.page - (this.page % this.visibleButtons);
        this.lastVisiblePage = this.firstVisiblePage + this.visibleButtons - 1;
        if (this.lastVisiblePage > this.lastPage) {
            this.lastVisiblePage = this.lastPage;
        }
        this.updateFirstLastVisibile();
    }
}
